import type { ClassSetupDraft } from "./classSetup";

export type ClassSetupProgress = {
  version: 1;
  step: number;
  hasHome: boolean;
  homeroom: string;
  teaching: ClassSetupDraft["teaching"];
  noTeaching: boolean;
};

export function parseClassSetupProgress(value: string | null): ClassSetupProgress | null {
  if (!value) return null;
  try {
    const progress = JSON.parse(value);
    if (
      progress?.version !== 1 ||
      ![0, 1, 2].includes(progress.step) ||
      typeof progress.hasHome !== "boolean" ||
      typeof progress.homeroom !== "string" ||
      typeof progress.noTeaching !== "boolean" ||
      !Array.isArray(progress.teaching) ||
      !progress.teaching.every(
        (row: unknown) =>
          row &&
          typeof row === "object" &&
          "className" in row &&
          typeof row.className === "string" &&
          "subject" in row &&
          typeof row.subject === "string",
      )
    )
      return null;
    return {
      version: 1,
      step: progress.step,
      hasHome: progress.hasHome,
      homeroom: progress.homeroom,
      teaching: progress.teaching.map((row: ClassSetupDraft["teaching"][number]) => ({
        className: row.className,
        subject: row.subject,
      })),
      noTeaching: progress.noTeaching,
    };
  } catch {
    return null;
  }
}
